var _rect, _rect2, _rect3, _rect4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCompanySilhouette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#e6effa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 34,
    width: 44,
    height: 98,
    rx: 2,
    fill: "#8fb3dd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 66,
    width: 30,
    height: 66,
    rx: 2,
    fill: "#a9c6e8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 130,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#8fb3dd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6effa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 44,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 44,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 44,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 62,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 62,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 62,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 80,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 98,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 98,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 98,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 114,
    width: 12,
    height: 18,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 76,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 76,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 93,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 93,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 110,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 110,
    width: 7,
    height: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompanySilhouette);
export default __webpack_public_path__ + "static/media/default-company-silhouette.2cc57fc5dc34d7521d3cba79d5d3bb9b.svg";
export { ForwardRef as ReactComponent };